import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";


import RTEquipments from "./Equipments/RTEquipments";
import RTSchedule from "./Schedules/RTSchedules";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
    textTransform: "none",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  tabPanel: {
    padding: "0",
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>{children}</>

      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}


export default function ControlVT(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2} lg={2}>
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleTabChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            TabIndicatorProps={{ style: { background: "#91C73C" } }}
          >
            <Tab className={classes.tab} label="Equipements" {...a11yProps(0)} />
            <Tab className={classes.tab} label="Plannings" {...a11yProps(1)} />
            {/* <Tab className={classes.tab} label="Connexions" {...a11yProps(2)} />
            <Tab className={classes.tab} label="Relance" {...a11yProps(3)} /> */}
          </Tabs>
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={10}>
          <TabPanel value={value} index={0} className={classes.tabPanel} >
            <RTEquipments />
          </TabPanel>
          <TabPanel value={value} index={1} className={classes.tabPanel} >
            <RTSchedule />
          </TabPanel>
          {/* <TabPanel value={value} index={2} className={classes.tabPanel} >
           
           </TabPanel>
           <TabPanel value={value} index={3} className={classes.tabPanel} >
           
           </TabPanel> */}
        </GridItem>
      </GridContainer>
    </div>

  );
}
